import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { saveLastAuthenticatedPath } from '../../utils/authRedirect';

export function AuthenticatedRouteTracker() {
  const { currentUser } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (currentUser) {
      saveLastAuthenticatedPath(currentUser.uid, location.pathname);
    }
  }, [currentUser, location.pathname]);

  return null;
}
